import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalBox = styled.div`
  background: #fff;
  width: min(500px, 92vw);
  padding: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContentIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: radial-gradient(
    circle at center,
    #edf4f8 70%,
    /* centro azul acinzentado */ #f9fbfc 100% /* borda quase branca */
  );
  display: grid;
  place-items: center;
  color: #005b82;
  font-size: 28px;
  box-shadow: 0 -12px 25px rgba(180, 200, 220, 0.6);
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  h3 {
    margin: 0;
    font-size: 18px;
    color: #0f172a;
  }
  p {
    margin: 0;
    font-size: 14px;
    color: #64748b;
    text-align: center;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 40px;
  button {
    min-width: 120px;
  }
`;

export const CloseX = styled.button`
  position: absolute;
  top: 2px;
  right: 20px;
  border: 0;
  font-weight: 200;
  background: transparent;
  font-size: 28px;
  color: #64748b;
  cursor: pointer;

  &:hover {
    color: #fd5d5d;
  }
`;

export const KeyInput = styled.input`
  width: 80%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 2px;
  font-size: 15px;
  text-align: center;
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.hoveredDiv};
  }
`;

export const ErrorText = styled.div`
  color: #b91c1c;
  font-size: 13px;
  margin-top: 8px;
  text-align: center;
`;

export const Button = styled.button`
  background: ${({ theme }) => theme.primary};
  color: #fff;
  padding: 8px 30px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 640px) {
    flex: 1; /* cada botão ocupa metade */
    padding: 12px 0; /* alvo de toque maior */
    font-size: 15px;
  }
`;
